module.exports = __webpack_public_path__ + "static/patient-privacy-disclosure.f3e1ac8c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/documents/patient-privacy-disclosure.pdf
// module id = 319
// module chunks = 140389645284302